import { fieldNames } from '../../../common/config';

export const selectFields = new Set([
  fieldNames.reason,
  fieldNames.type,
  fieldNames.responsible,
  fieldNames.alisaTemplate,
]);

export const cityDependentFields = new Set([
  fieldNames.city,
  fieldNames.initiators,
  fieldNames.notifyTo,
  fieldNames.addresses,
]);

export const companyDependentFields = new Set([fieldNames.company]);

export const insertDraftDataKeys = {
  selectValues: 'selectValues',
  cityDependentValues: 'cityDependentValues',
  companyDependentValues: 'companyDependentValues',
  restValues: 'restValues',
};

export const initDraftData = Object.values(insertDraftDataKeys).reduce(
  (acc, value) => {
    acc[value] = {};
    return acc;
  },
  {}
);
